import * as Yup from "yup";

export const messageTemplateSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required"),
  smsEventStatus: Yup.string().required("Event is required"),
  message: Yup.string()
    .trim()
    .required("Message is required")
    // 160 is one SMS segment; longer messages bill as multiple parts.
    .max(480, "Message cannot exceed 480 characters (3 SMS segments)"),
});

export const smsGatewaySchema = Yup.object().shape({
  name: Yup.string().trim().required("Gateway name is required"),
  description: Yup.string().trim().required("Description is required"),
});

export const smsChargeSchema = Yup.object().shape({
  fee: Yup.number()
    .typeError("Fee must be a number")
    .min(0, "Fee cannot be negative")
    .required("Fee is required"),
});